import React from "react"
import { BodyTextSemibold } from "../typography/text"
import { routes } from "../../routes"
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next"
import { translationKeys } from "../../util/translationKeys"
import { useCatering } from "../../context/catering-context/useCatering"
import { ActionSuccessfulTemplate } from "./ActionSuccessfulTemplate"
import { captureException } from "../../services/exception-logger"

type Props = {
  orderId: string
}

export const PaymentSuccessfulScreen = ({ orderId }: Props) => {
  const { navigate } = useI18next()
  const { t } = useTranslation()
  const { isCatering } = useCatering()

  const subtitle = isCatering
    ? t(translationKeys.cateringOrderSuccessSubtitle)
    : t(translationKeys.webOrderReceivedSubtitle)

  const buttonText = isCatering
    ? t(translationKeys.comboGoToRestaurants)
    : t(translationKeys.webOrderReceivedCtatext)

  return (
    <ActionSuccessfulTemplate
      buttonText={buttonText}
      buttonOnClick={() => {
        if (!orderId) {
          // TODO if we notice this is happening to users, handle error in UI and troubleshoot in code
          captureException(
            new Error("Order ID is undefined on payment successful screen!"),
            {
              type: "business_logic",
              category: "invalid-state",
              context: { errorSource: "PaymentSuccessfulScreen" },
            }
          )
          return
        }
        if (isCatering) {
          navigate(routes.restaurants())
        } else {
          navigate(`${routes.orderStatus}/?orderId=${orderId}`)
        }
      }}
      header={t(translationKeys.webOrderReceived)}
      subtitle={subtitle}
      additionalSubtitleComponent={
        isCatering ? (
          <BodyTextSemibold className="mt-4 text-center text-foreground-base w-auto md:w-[440px]">
            {t(translationKeys.cateringOrderSuccessSubtitleObs)}
          </BodyTextSemibold>
        ) : undefined
      }
    />
  )
}
